define('SC.ThreadsThemeExtension.ItemRelations.SC.Configuration', [
  'SC.ThreadsThemeExtension.Common.Configuration'
], function ThemeExtensionItemRelations(Configuration) {
  'use strict';
  return {
    loadModule: function loadModule() {
      var overallConfiguration = Configuration.getOverallConfiguration();
      if (
        overallConfiguration.bxSliderDefaults &&
        overallConfiguration.bxSliderDefaults.slideWidth
      ) {
        overallConfiguration.bxSliderDefaults.slideWidth = 296;
        overallConfiguration.bxSliderDefaults.maxSlides = 4;
      }
    }
  };
});
